import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { TileList } from '@as/cotopaxi';
import { useSelector } from 'react-redux';
import { makeGetBundleSelectedSlots } from '../../redux/product/selectors/ProductSelector';
import { ProductBundleTileItem } from './ProductBundleTileItem';
export const ProductBundleDeals = ({ bundle }) => {
    const selectedSlots = useSelector(makeGetBundleSelectedSlots());
    return (_jsx(_Fragment, { children: _jsx(TileList, { tileListName: `bundle-${bundle.bundleId}`, selectable: true, selectedItems: selectedSlots, children: bundle.bundleSlots.map(slot => (_jsx(ProductBundleTileItem, { productSlot: slot, isMonetateBundle: bundle.isMonetateBundle }, slot.slotNumber))) }) }));
};
